export const LogoMark = ({ className = "h-8 w-8" }) => (
  <svg viewBox="0 0 32 32" className={className} aria-hidden="true">
    <rect width="32" height="32" rx="8" fill="#17140f" />
    <path d="M8 13h9M8 18h13M8 23h7" stroke="#f7f1e6" strokeWidth="2.2" strokeLinecap="round" />
    <path d="M24.5 5.5c-3.6 0-6 2.3-6 5.8 3.6 0 6-2.3 6-5.8z" fill="#a9bba4" />
    <circle cx="23.5" cy="23" r="2.4" fill="#c8452c" />
  </svg>
);

export const Logo = () => (
  <a href="/#top" className="group flex items-center gap-2.5" data-testid="nav-brand">
    <LogoMark className="h-8 w-8 transition-transform duration-500 group-hover:-rotate-6" />
    <span className="font-display text-[15px] leading-[1.05] sm:text-lg">Meal Planning and<br />Grocery Systems</span>
  </a>
);
